import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { useAuthStore } from '../store/auth.store';

interface CurrentVenue {
  id: string;
  name: string;
  code: string;
}

// A memory-only revision isolates responses across login, refresh and venue changes.
// Tokens and remembered login choices never enter the query key or venue label.
export function currentVenueOptions(revision: number, enabled: boolean) {
  return queryOptions({
    queryKey: ['current-venue', revision],
    enabled,
    queryFn: async ({ signal }) => {
      const profile = await api.get<{ venueId: string; venue: CurrentVenue }>('/auth/profile', {
        signal,
      });
      if (
        !profile.venue ||
        profile.venue.id !== profile.venueId ||
        !profile.venue.code ||
        !profile.venue.name
      ) {
        throw new Error('Current venue is unavailable');
      }
      return profile.venue;
    },
    retry: false,
    staleTime: 60_000,
    gcTime: 0,
  });
}

export function useCurrentVenue() {
  const revision = useAuthStore((s) => s.authRevision);
  const enabled = useAuthStore((s) => Boolean(s.accessToken) && s.isAuthenticated);
  const query = useQuery(currentVenueOptions(revision, enabled));
  return { ...query, venue: enabled && !query.isError ? query.data : undefined };
}
